import React from "react";
import AddressComponent from "../../../../shared/AddressComponent";

const ShippingRadioContentComponent = ({ entity }) => (
  <AddressComponent address={entity} />
);

export default ShippingRadioContentComponent;
